var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 46 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8.2H8.1C3.7.2.2 3.7.2 8.1v26c0 4.4 3.5 7.9 7.9 7.9h29.7c4.4 0 7.9-3.5 7.9-7.9v-26c0-4.4-3.5-7.9-7.9-7.9zm4.3 33.9c0 2.4-1.9 4.2-4.2 4.2H8.2c-2.4 0-4.2-1.9-4.2-4.2v-26c0-2.4 1.9-4.2 4.2-4.2h29.7c2.4 0 4.2 1.9 4.2 4.2v26z",
    fill: "#304256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7 13.2c.2-1.9 1.1-3.3 2.9-4.1.8-.3 1.7-.5 2.5-.5.9 0 1.7.2 2.5.5 1.8.8 2.7 2.2 2.9 4.1v.9c0 2-.5 3.9-1.3 5.7-.4.9-1 1.7-1.7 2.4s-1.6 1.1-2.5 1c-.9 0-1.8-.3-2.5-1s-1.3-1.5-1.7-2.4c-.8-1.8-1.2-3.7-1.3-5.7.2-.3.2-.6.2-.9zm18.7 19.5c-.1-1.5-.2-2.9-.6-4.3-.2-.4-.3-.8-.5-1.1-.3-.3-.7-.7-1-.8-.9-.3-1.9-.5-2.8-.7-1.5-.4-2.8-.7-4.3-1.1h-.1c-2.1.8-5 .9-7.3-.1h-.2c-1.3.3-2.6.6-3.8.9l-3.3.9c-.4.1-.7.4-1 .7l-.1.1c-.3.3-.4.7-.5 1.1-.4 1.2-.5 2.5-.6 3.8v.5c0 .9-.2.7.7 1.1.2.1.4.2.7.3 1.6.5 3.2.9 4.9 1.1 1.6.2 3.2.3 4.9.4h3.7c2.6-.1 5.1-.3 7.7-.9.7-.2 1.4-.3 2.1-.6.2-.1.4-.2.7-.3.8-.3.7-.1.7-1z",
    fill: "#424D56"
  }))));
}

export default SvgClient;